export const email = (value) => {
    if (value.length && !/^\S+@\S+\.\S+$/.test(value)) {
        return 'Неверный формат';
    }
    return null;
};
